import { computed, ref } from 'vue'

export function sortable(source, options = null) {
    const field = ref(options?.field ?? null)
    const direction = ref(options?.direction ?? 'asc')
    const sorters = options?.sorters ?? {}

    const fetch = computed(() => {
        let f = field.value?.trim() ?? ''

        if (f === '') {
            return null
        }

        if (f.indexOf('.') > -1) {
            f = f.split('.').map(v => v.trim())
            return o => f.reduce((p, c) => (p !== null && p !== undefined ? p[c] : p), o)
        }

        return o => o[f]
    })

    const comparer = computed(() => {
        const f = fetch.value

        if (f === null) {
            return null
        }

        const sorter = sorters[field.value?.trim() ?? '']

        if (sorter) {
            return (lhs, rhs) => sorter(lhs, rhs, f)
        }

        return (lhs, rhs) => {
            lhs = f(lhs)
            rhs = f(rhs)

            if (typeof lhs === 'string' || typeof rhs === 'string') {
                return (lhs || '').localeCompare(rhs || '', 'en', { sensitivity: 'base' })
            }

            return (lhs || 0) - (rhs || 0)
        }
    })

    const sorter = computed(() => {
        const c = comparer.value

        if (c === null) {
            return null
        }

        if (direction.value === 'desc') {
            return (lhs, rhs) => c(rhs, lhs)
        }

        return c
    })

    const all = computed(source)
    const sorted = computed(() => {
        if (sorter.value === null) {
            return all.value
        }

        return all.value.slice(0).sort(sorter.value)
    })

    return {
        get sortField() {
            return field.value
        },
        set sortField(value) {
            field.value = value
        },
        get sortDirection() {
            return direction.value
        },
        set sortDirection(value) {
            direction.value = value
        },
        get sort() {
            return {
                direction: direction.value,
                field: field.value,
            }
        },
        set sort(value) {
            direction.value = value?.direction ?? null
            field.value = value?.field ?? null
        },
        get results() {
            return sorted.value
        },
    }
}
